import { OfflineBanner, ToastProvider } from '@pharmaconnect/ui/web'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { I18nProvider } from './i18n/I18nProvider'
import { installGlobalErrorTracker } from './lib/errorTracker'
import { useAuthStore } from './stores/authStore'

import './index.css'

// Capture les erreurs JS non gérées (window.onerror + unhandledrejection)
// et les remonte dans public.error_logs pour debug à distance des pilotes.
installGlobalErrorTracker()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Charge la session existante avant le premier paint
void useAuthStore.getState().bootstrap()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element introuvable')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <BrowserRouter>
            <OfflineBanner />
            <App />
          </BrowserRouter>
        </ToastProvider>
      </QueryClientProvider>
    </I18nProvider>
  </React.StrictMode>,
)
